import React, { memo, useState } from 'react'
import DownArrowIcon from 'transfix-icons/build/DownArrowIcon'
import UpArrowIcon from 'transfix-icons/build/UpArrowIcon'
import Badge from 'transfix-ui/components/Badge'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { makeStyles, Skeleton, Typography } from 'transfix-ui/core'
import { ICarrierRelatedOptionDetailsFragment } from '../../graphql/CarrierRelatedOptionDetailsFragment'
import RelatedOptionsRow from './components/RelatedOptionsRow'

export interface IRelatedOptionsCardProps {
  relatedOptions?: ICarrierRelatedOptionDetailsFragment[]
  loading: boolean
}

const useRelationOptionsStyles = makeStyles(theme => ({
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
  },
  titleCount: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },
}))

const RelatedOptionsCard = memo<IRelatedOptionsCardProps>(
  ({ relatedOptions = [], loading = false }) => {
    const classes = useRelationOptionsStyles()
    const optionsCount = relatedOptions.length

    const [isCollapsed, setIsCollapsed] = useState<boolean>(false)
    const text = optionsCount === 1 ? 'Related Option' : 'Related Options'

    const toggleCollapsible = () => {
      setIsCollapsed(current => !current)
    }

    return (
      <Card noPadding>
        <div className={classes.titleRow}>
          <div className={classes.titleCount}>
            <Typography variant='subtitle1'>{text}</Typography>
            {loading ? (
              <Skeleton variant='rectangular' width={15} height={18} />
            ) : (
              <Badge label={`${optionsCount}`} />
            )}
          </div>
          <div>
            {optionsCount >= 1 && (
              <IconButton
                Icon={isCollapsed ? UpArrowIcon : DownArrowIcon}
                onClick={toggleCollapsible}
                noPadding
                size='large'
              />
            )}
          </div>
        </div>
        {isCollapsed && (
          <div>
            {relatedOptions.map(
              ({ amount, carrierApplication, createdAt, createdBy, id, status }) => (
                <div key={id}>
                  <RelatedOptionsRow
                    id={id}
                    amount={amount}
                    status={status}
                    carrierApplication={carrierApplication}
                    createdAt={createdAt}
                    createdBy={createdBy}
                  />
                </div>
              )
            )}
          </div>
        )}
      </Card>
    )
  }
)

export default RelatedOptionsCard
